import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem.js';
import {
  Flag as DisputesIcon,
  CornerRightDown as PayoutIcon,
  CornerRightUp as TopupIcon
} from 'react-feather';
import { BsArrowDownUp } from 'react-icons/bs';

const useStyles = makeStyles({
  boxActive: {
    borderLeft: '2px solid #3f51b5',
    height: 20,
    paddingRight: 20
  },
  boxes: {
    borderLeft: '1px solid #f5f5ff',
    paddingRight: 20,
    '&:hover': {
      borderLeft: '1px solid #c7c7c7'
    }
  },
  box: { margin: '20px 70px 0px 0px', position: 'fixed' },
  textActive: {
    borderRight: '2px solid #3f51b5'
  },
  // mainBox: {
  //   marginBottom: 2
  // },
  mainBoxActive: {
    marginBottom: 2
  },
  text: {
    fontSize: 17,
    color: '#3e4040'
  },
  mainText: {
    fontSize: 17,
    color: '#3f51b5',
    fontWeight: 500
  },
  buttons: {
    marginTop: 10
  }
});

const BalanceTab = ({ val }) => {
  const [active, setActive] = React.useState('stores');
  React.useEffect(() => {
    setActive(val);
  }, [val]);
  const classes = useStyles();
  return (
    <>
      <Box className={classes.box}>
        <Typography
          style={{
            color: '#3e4040',
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'Ubuntu',
            marginBottom: 10,
            marginLeft: 7
          }}
        >
          Balance
        </Typography>
        <Box
          className={
            active == 'balance' ? classes.mainBoxActive : classes.mainBox
          }
        >
          <Box
            className={active == 'balance' ? classes.boxActive : classes.boxes}
          >
            <Box
              className={active == 'balance' ? classes.mainText : classes.text}
              variant="p"
            >
              <NavItem
                className={classes.itemlistfirst}
                href="/app/balances"
                title={
                  <Typography
                    variant="p"
                    className={
                      active == 'balance' ? classes.mainText : classes.text
                    }
                  >
                    {'Balance'}
                  </Typography>
                }
                icon={BsArrowDownUp}
              />
            </Box>
          </Box>
        </Box>

        <Box
          className={
            active == 'topups' ? classes.mainBoxActive : classes.mainBox
          }
        >
          <Box
            className={active == 'topups' ? classes.boxActive : classes.boxes}
          >
            <Box
              className={active == 'topups' ? classes.mainText : classes.text}
              variant="p"
            >
              <NavItem
                className={classes.itemlistfirst}
                href="/app/topups"
                title={
                  <Typography
                    variant="p"
                    className={
                      active == 'topups' ? classes.mainText : classes.text
                    }
                  >
                    {'Top-ups'}
                  </Typography>
                }
                icon={TopupIcon}
              />
            </Box>
          </Box>
        </Box>
        <Box
          className={
            active == 'payouts' ? classes.mainBoxActive : classes.mainBox
          }
        >
          <Box
            className={active == 'payouts' ? classes.boxActive : classes.boxes}
          >
            <Box
              className={active == 'payouts' ? classes.mainText : classes.text}
              variant="p"
            >
              <NavItem
                className={classes.itemlistfirst}
                href="/app/payouts"
                title={
                  <Typography
                    variant="p"
                    className={
                      active == 'payouts' ? classes.mainText : classes.text
                    }
                  >
                    {'Payouts'}
                  </Typography>
                }
                icon={PayoutIcon}
              />
            </Box>
          </Box>
        </Box>
        {/* <Box
          className={
            active == 'balance' ? classes.mainBoxActive : classes.mainBox
          }
        >
          <Box
            className={active == 'balance' ? classes.boxActive : classes.boxes}
          >
            <Box
              className={active == 'balance' ? classes.mainText : classes.text}
              variant="p"
            >
              <NavItem
                className={classes.itemlistfirst}
                href="/app/balances"
                title={
                  <Typography
                    variant="p"
                    className={
                      active == 'balance' ? classes.mainText : classes.text
                    }
                  >
                    {'Balance'}
                  </Typography>
                }
                icon={TopupIcon}
              />
            </Box>
          </Box>
        </Box> */}
        <Box
          className={
            active == 'disputes' ? classes.mainBoxActive : classes.mainBox
          }
        >
          <Box
            className={active == 'disputes' ? classes.boxActive : classes.boxes}
          >
            <Box
              className={active == 'disputes' ? classes.mainText : classes.text}
              variant="p"
            >
              <NavItem
                className={classes.itemlistfirst}
                href="/app/disputes"
                title={
                  <Typography
                    variant="p"
                    className={
                      active == 'disputes' ? classes.mainText : classes.text
                    }
                  >
                    {'Disputes'}
                  </Typography>
                }
                icon={DisputesIcon}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BalanceTab;
